import { ISelect, arrayToObject } from '@treelab/panda';
import { IStatus } from '@treelab/common-logic';

export const getSelectOptionsWithData = (ids: string[] | undefined, options: ISelect[]) => {
  /**
   * ex. ids = ['id123'], options = [{optionId: 'id123', color: 'blue'}]
   * returns [{optionId: 'id123', color: 'blue'}]. It's possible some of the options do not match
   * with the ids. This happens when the user goes to the field config and deletes an option.
   */
  if (!ids) return [];

  const optionsById = arrayToObject(options, 'optionId');
  return ids.map((id) => optionsById[id]).filter((t) => !!t);
};

export const getStatusOptionsWithData = (ids: string[] | undefined, options: IStatus[]) => {
  /**
   * ex. ids = ['id123'], options = [{optionId: 'id123', color: 'blue'}]
   * returns [{optionId: 'id123', color: 'blue'}]. It's possible some of the options do not match
   * with the ids. This happens when the user goes to the field config and deletes an option.
   */
  if (!ids) return [];

  const optionsById = arrayToObject(options, 'statusId');
  return ids.map((id) => optionsById[id]).filter((t) => !!t) as IStatus[];
};